var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-block",class:_vm.classModifier},[(_vm.data.ctype === 'textmedia')?_c('block-default',{attrs:{"block":_vm.data,"seamless":_vm.seamless}}):(_vm.data.ctype === 'header')?_c('block-header',{attrs:{"block":_vm.data,"seamless":_vm.seamless}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75e8943e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/MasterBlock.vue
// module id = null
// module chunks = 